import { useLayoutEffect } from 'react'

import { useMapContext } from './MapContext'
import { safeAddLayer, safeAddSource, safeRemoveLayer, safeRemoveSource } from './mapTeardown'

interface MapStackLayerProps {
  id: string
}

function MapStackLayer(props: MapStackLayerProps): null {
  const { id } = props

  const { map } = useMapContext()

  useLayoutEffect(() => {
    if (!map) return

    safeAddSource(map, `${id}-source`, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    })

    safeAddLayer(map, {
      id,
      type: 'raster',
      source: `${id}-source`
    })

    return () => {
      // Remove the layer before its source — Mapbox refuses to drop a source
      // still referenced by a layer.
      safeRemoveLayer(map, id)
      safeRemoveSource(map, `${id}-source`)
    }
  }, [map])

  return null
}

export { MapStackLayer }
